import {all, call, fork, put, select, takeEvery} from 'redux-saga/effects';
import {apiClient} from '../../../shared/api';
import {notifyError, notifySuccess} from '../../../shared/notificationUtils';

import axios from 'axios';

import {
    CREAT_BATCH_SCAN,
    DELETE_DOCUMENT_FROM_SESSION,
    EDIT_DOCUMENT_IN_SESSION,
    EXECUTE_BATCH_SCAN,
    GET_ALL_TEMPLATES,
    SELECT_TEMPLATE,
    UPLOAD_DOCUMENT,
    UPLOAD_DOCUMENT_SUCCESS,
} from './constants';

import {
    createBatchScan as createBatchScanAction,
    createBatchScanFailed,
    createBatchScanSuccess,
    deleteDocumentFromSessionFailed,
    deleteDocumentFromSessionSuccess,
    editDocumentInSessionFailed,
    editDocumentInSessionSuccess,
    executeBatchScanFailed,
    executeBatchScanSuccess,
    getAllTemplatesFailed,
    getAllTemplatesSuccess,
    getUploadingDocumentFailed,
    getUploadingDocumentSuccess,
    subscribeUploadingDocument,
    uploadDocumentFailed
} from './actions';

const END_POINT_SCAN = 'document-service/api/v2/scan/batches';

const getState = (state) => {
    return state.ScanCore
};

function* getAllTemplates() {
    const response = yield call(apiClient.list, 'api/v2/templates/scan/');
    if (response.error) {
        yield put(getAllTemplatesFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(getAllTemplatesSuccess(response.data));
    }
}

function* selectTemplate({payload: {resource_id}}) {
    yield put(createBatchScanAction(resource_id));
}

function* createBatchScan({payload: {doc_type}}) {
    const options = {
        method: 'post',
    };
    const response = yield call(apiClient.request, `${END_POINT_SCAN}?doc_type=${doc_type}`, options);
    if (response.error) {
        yield put(createBatchScanFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(createBatchScanSuccess(response.data));
    }
}


function* requestUploadUrl(file, batchId: string, mapId: string) {
    let body = {
        batch_id: batchId,
        map_id: mapId,
        file_name: file.name,
    };

    // step 1: request upload url
    let response = yield call(
        apiClient.request, `${END_POINT_SCAN}/request-upload-url`, {
            method: 'post',
            body
        }
    );

    // step 2: upload file to s3
    const url = response.data.url;
    const key_fields = response.data.fields;

    response = yield call(apiClient.uploadFileIntoS3, file, url, key_fields)

    return {
        response,
        fileKey: key_fields.key
    }
}

function* chooseUploadType(file, batchId, mapId) {
    const formData = new FormData();
    formData.set('batch_id', batchId);
    formData.set('map_id', mapId);

    const fileSize = file.size / 1024 / 1024; // in MB
    if (fileSize > 9) {
        // step 2.1: request upload url
        let {response, fileKey} = yield call(requestUploadUrl, file, batchId, mapId);
        if (response.status !== 204) {
            yield call(notifyError, 'Cannot upload file, try again');
            return;
        }
        formData.set('file_key', fileKey);
    } else {
        // step 2.2: append upload file to form data
        formData.append('image', file);
    }

    return formData;
}

function* uploadDocument({payload: {file, mapId}}) {

    let state = yield select(getState);
    const {batchId, selectedTemplate} = state;

    // step 1: choose upload type base on file size
    const formData = yield call(chooseUploadType, file, batchId, mapId);
    formData.set('doc_type', selectedTemplate['resource_id']);

    // step 2: send scan request to backend
    const response = yield call(
        apiClient.post, `${END_POINT_SCAN}/upload`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }
    );

    if (response.error) {
        yield put(uploadDocumentFailed({mapId, error: response.detail}));
        yield call(notifyError, 'An error has occurred');
    } else if (response.data && response.data.data && response.data.data.data) {
        yield put(subscribeUploadingDocument(response.data.data.data));
    }
    // do nothing
}

function* getUploadingDocument({payload: {batchId, mapId}}) {
    const options = {
        method: 'get'
    };
    const response = yield call(apiClient.request, `${END_POINT_SCAN}/${batchId}?map_id=${mapId}`, options);
    if (response.error) {
        yield put(getUploadingDocumentFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(getUploadingDocumentSuccess(response));
    }
}

function* editDocumentInSession({payload: document}) {
    let state = yield select(getState);
    const options = {
        method: 'put',
        body: document
    };
    const {batchId} = state;
    let response = yield call(apiClient.request, `${END_POINT_SCAN}/${batchId}`, options);
    if (response.error) {
        yield put(editDocumentInSessionFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(editDocumentInSessionSuccess({mapId: document.resource_id, ...response.data}));
    }
}

function* deleteDocumentFromSession({payload: mapId}) {
    let state = yield select(getState);
    const options = {
        method: 'delete'
    };
    const {batchId} = state;
    let response = yield call(apiClient.request, `${END_POINT_SCAN}/${batchId}?doc_type=${state.selectedTemplate.resource_id}&map_id=${mapId}`, options);
    if (response.error) {
        yield put(deleteDocumentFromSessionFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(deleteDocumentFromSessionSuccess({mapId: mapId, session: response.data.session}));
    }
}

function* executeBatchScan() {
    let state = yield select(getState);
    const options = {
        method: 'post',
    };
    const {batchId} = state;
    // const response = yield call(request, 'batches1', options);
    const response = yield call(apiClient.request, `${END_POINT_SCAN}/${batchId}/execution`, options);
    if (response.error) {
        yield put(executeBatchScanFailed(response.detail));
        yield call(notifyError, 'An error has occurred');
    } else {
        yield put(executeBatchScanSuccess(response.data.results));
        yield call(notifySuccess, 'Successfully upload');
    }
}

export function* watchGetAllTemplates(): any {
    yield takeEvery(GET_ALL_TEMPLATES, getAllTemplates);
}

export function* watchSelectTemplate(): any {
    yield takeEvery(SELECT_TEMPLATE, selectTemplate);
}

export function* watchCreateBatchScan(): any {
    yield takeEvery(CREAT_BATCH_SCAN, createBatchScan);
}

export function* watchUploadDocument(): any {
    yield takeEvery(UPLOAD_DOCUMENT, uploadDocument);
}

export function* watchUploadDocumentSuccess(): any {
    yield takeEvery(UPLOAD_DOCUMENT_SUCCESS, getUploadingDocument);
}

export function* watchEditDocumentInSession(): any {
    yield takeEvery(EDIT_DOCUMENT_IN_SESSION, editDocumentInSession);
}

export function* watchDeleteDocumentFromSession(): any {
    yield takeEvery(DELETE_DOCUMENT_FROM_SESSION, deleteDocumentFromSession);
}

export function* watchExecuteBatchScan(): any {
    yield takeEvery(EXECUTE_BATCH_SCAN, executeBatchScan);
}

function* scanSaga(): any {
    yield all([
        fork(watchGetAllTemplates),
        fork(watchSelectTemplate),
        fork(watchCreateBatchScan),
        fork(watchUploadDocument),
        fork(watchUploadDocumentSuccess),
        fork(watchEditDocumentInSession),
        fork(watchDeleteDocumentFromSession),
        fork(watchExecuteBatchScan),
    ]);
}

export default scanSaga;
